import { useGetAuthorizationMutation } from "@auth/service/authLoginService";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"

export const useAuthorization = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [executeIsAuthorized, { isLoading: isLoadingAuthorization }] = useGetAuthorizationMutation();
    const [isInitialLoading, setIsInitialLoading] = useState(true);

    useEffect( () => { 
        const getAuthorization = async () => {
            try {
                const data = await executeIsAuthorized({ point: pathname}).unwrap();
                if (!data.access) {
                    navigate('/unauthorized', { replace: true });
                }
            } catch (error) {
                navigate('/dashboard', {replace: true});
            }finally {
                setIsInitialLoading(false);
            }
        };

        getAuthorization().then();
    }, [executeIsAuthorized, pathname, navigate])

    return {
        isLoadingAuthorization: isLoadingAuthorization || isInitialLoading,
    }
}